import { HUText } from "@modules/ui/components/huText"
import { useTheme } from "styled-components"

/**
 * Composant for render chart with bars in the Training page
 * @param number
 * @param date
 * @returns
 */
const HuBars = ({ number, date, heightBar }: { number: number; date: string; heightBar:number }) => {
  const theme = useTheme()

  return (
    <div className="flex flex-column justify-content-end align-items-center h-full w-3">
      <div className="flex flex-row gap-1 h-full align-items-end">
        <HUText color={theme.mainBlack} fontStyle="TM">
          {number}
        </HUText>
        <div className="bg-black rounded-full" style={{width:"14px", height:`${heightBar}%`}}>
        </div>
      </div>
      <div className="mt-1">
        <HUText color={theme.mainBlack} fontStyle="BS">
          {date}
        </HUText>
      </div>
    </div>
  )
}

export default HuBars
